import { defineStore } from "pinia";

export const useTeamStore = defineStore("teamStore", {
  state: () => ({
    selectedTeam: null,
    myTeam: null,
    allTeams: [],
  }),
  actions: {
    setSelectedTeam(team) {
      this.selectedTeam = team;
    },
    setMyTeam(team) {
      this.myTeam = team;
    },
    setAllTeams(teams) {
      this.allTeams = teams;
    },
    renameTeam(newName) {
      const selectedTeam = this.selectedTeam?.team;
      const myTeam = this.myTeam?.team;
      if (selectedTeam?.name && myTeam?.name && selectedTeam.id === myTeam.id) {
        this.selectedTeam.team.name = newName;
      }
      if (myTeam) {
        this.myTeam.team.name = newName;
      }
    },
  },
});

export default useTeamStore;
